import { AssignKioskRepository } from '../data/assign-kiosk-repository';
import { MachineDefaultCredit, MachineDefaultCreditResponse } from '../types/assign-kiosk-types';

export interface GetMachineDefaultCreditResult {
  data: MachineDefaultCredit | null;
  hasError: boolean;
  errorMessage?: string;
}

/** Lynx stores Default Credit in the smallest currency unit; attr 523 tells how many decimal places. */
const DEFAULT_DECIMAL_PLACES = 2;

export function toMachineDefaultCredit(response: MachineDefaultCreditResponse): MachineDefaultCredit {
  const raw = response.defaultCreditRaw ?? NaN;
  const decimals = response.decimalPlaces != null && response.decimalPlaces >= 0
    ? response.decimalPlaces
    : DEFAULT_DECIMAL_PLACES;
  // 0 / missing = unlimited in Lynx → no ceiling
  const amount = Number.isFinite(raw) && raw > 0 ? raw / Math.pow(10, decimals) : null;
  return {
    amount,
    currencyCode: response.currencyCode ?? null,
    currencySign: response.currencySign ?? null,
  };
}

export class GetMachineDefaultCreditUseCase {
  constructor(private readonly repository: AssignKioskRepository) {}

  async execute(machineId: string): Promise<GetMachineDefaultCreditResult> {
    try {
      const response = await this.repository.getMachineDefaultCredit(machineId);
      return { data: toMachineDefaultCredit(response), hasError: false };
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to load default credit';
      return { data: null, hasError: true, errorMessage };
    }
  }
}
